import { render, staticRenderFns } from "./RecentTransaction.vue?vue&type=template&id=dc8d778e&scoped=true&"
import script from "./RecentTransaction.vue?vue&type=script&lang=js&"
export * from "./RecentTransaction.vue?vue&type=script&lang=js&"
import style0 from "./RecentTransaction.vue?vue&type=style&index=0&id=dc8d778e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8d778e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})
